module.exports = __webpack_public_path__ + "static/img/bussinessImg2.eb72c90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bussinessImg2.jpg
// module id = s/1p
// module chunks = 1